// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ySiftGDocEf7C1 {\n  height: 32px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  overflow: hidden;\n  width: 70%;\n  margin: 0 auto;\n}\n.ySiftGDocEf7C1::before {\n  content: '';\n  display: block;\n  width: 100%;\n  border-top: 2px solid var(--ds-border, #C1C7D0);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separatorCardFront": "ySiftGDocEf7C1"
};
export default ___CSS_LOADER_EXPORT___;
